import type { ColumnSettings, GridSettings } from '@/support/hot.types';
import { buildTreatmentNameValidator, NAME_PROPERTY } from '@/utils/treatmentTypeValidation';

/**
 * Column definition for the bulk create grid: a single treatment name column, validated by a
 * hybrid validator so the grid can recover the reason a name was rejected.
 */
export const buildColumns = (): Array<ColumnSettings> => [
  {
    data: NAME_PROPERTY,
    type: 'text',
    className: 'htMiddle',
    validator: buildTreatmentNameValidator(),
  },
];

export const initBulkAddTreatmentsSettings = (columns: Array<ColumnSettings>): GridSettings => ({
  columns,
  colHeaders: ['Name'],
  // Rows are objects rather than cell arrays, so the spare row Handsontable appends must be
  // given the same shape — without a schema it would be created as a bare array.
  dataSchema: { [NAME_PROPERTY]: null },
  rowHeaders: true,
  manualColumnResize: true,
  contextMenu: {
    items: {
      row_above: {},
      row_below: {},
      remove_row: {},
    },
  },
  outsideClickDeselects: false,
  height: 400,
  rowHeights: 50,
  className: 'htMiddle',
  stretchH: 'all' as const,
  minSpareRows: 1,
});
